module.exports = __webpack_public_path__ + "img/palmas-resort.fa774b5c.jpg";